{
  "account": {
    "title": "حسابي",
    "list": {
      "title": "الحسابات",
      "description": "قائمة الفواتير للحسابات المرتبطة"
    },
    "form": {
      "name": {
        "title": "الاسم",
        "description": "اسم حسابك"
      },
      "password": {
        "title": "كلمة المرور",
        "description": "اضبط كلمة مرور جديدة لحسابك، اتركها فارغة للإبقاء على كلمة المرور الحالية"
      },
      "emailPreferences": {
        "title": "تفضيلات البريد الإلكتروني",
        "description": "حدد أنواع إشعارات البريد الإلكتروني"
      }
    },
    "billing": "تفاصيل الفواتير",
    "subscriptions": "الاشتراكات",
    "manageSubscription": "إدارة الاشتراك",
    "popup": {
      "cancel": "هل أنت متأكد من إلغاء اشتراكك؟<br/>ستظهر موقعك يتمثل حتى نهاية فترة اشتراكك الحالية. بعد ذلك، سيتم تعطيل الترجمة.<br/>يرجى الملاحظة أنك لن تكون مؤهلاً لاسترداد المدة غير المستخدمة.",
      "downgrade": "هل أنت متأكد من التخفيض؟ سيتم تطبيق التخفيض على الفور.<br/>يرجى الملاحظة أنك لن تكون مؤهلاً لاسترداد الوقت المتبقي من الدورة الفوترية الحالية.<br/>سيتم تطبيق سعر الخطة الجديدة في الدورة الفوترية التالية.",
      "default": "هل أنت متأكد من أنك تريد تغيير خطتك؟",
      "resume": "هل أنت متأكد من رغبتك في استئناف اشتراكك؟"
    }
  },
  "ai_translation": {
    "header": "ترجمة AI",
    "plan": {
      "header": "أسعار ترجمة AI",
      "used": "لقد استخدمت {words_used} / {words_allowed} من الكلمات المترجمة في رصيدك AI.",
      "remaining": "رصيد AI المتاح:",
      "words": "كلمة",
      "add_more_credits": "أضف المزيد من رصيد AI",
      "details": {
        "idiomatic_expressions": "التعابير الاصطلاحية والتقنية",
        "background_translation": "الترجمات في الخلفية",
        "best_website": "المواقع التي تتطلب جودة ترجمة مثالية",
        "page_context": "سياق الصفحة والموقع للترجمة",
        "perfect_quality": "جودة مثالية وسعر مناسب",
        "no_recurring": "لا توجد مدفوعات متكررة، حصة مسبقة الدفع",
        "save_40": "وفر 40% مقارنة بخطة 20$",
        "save_50": "وفر 50% مقارنة بخطة 20$"
      },
      "quota": "{estimated_words} كلمة ~ {estimated_pages} صفحة"
    },
    "settings": {
      "banner": {
        "title": "ترجمة لينغويز AI",
        "intro": "تفخر لينغويز بالكشف عن ترجمة لينغويز AI، ميزة بريميوم جديدة تستفيد من نماذج AI LLM (نماذج Llama الأحدث والمحسّنة لمهام الترجمة). صُممت للمواقع التي تتطلب دقة لا تشوبها شائبة، تأخذ بعين الاعتبار سياق الصفحة والموقع بأكمله لنتائج لا مثيل لها. منح عملائك قمة جودة الترجمة، مما يضمن أن رسالتهم تنبض بالكمال في كل لغة.",
        "button": "حدّث الآن"
      },
      "alert": {
        "description": "هذه الميزة غير مضمنة في خطتك الحالية وتتطلب شراء منفصل.\nفعّل هذا الإضاف لإلغاء قفل جميع الخيارات المدرجة أدناه."
      },
      "languages": {
        "title": "تطبيق ترجمة AI على اللغات",
        "description": "حدد لغة معينة تريد تطبيق ترجمة AI عليها"
      },
      "button": {
        "save": "حفظ الإعدادات"
      },
      "form": {
        "advanced": {
          "title": "تعليمات AI المتقدمة",
          "description": "تعليمات AI المتقدمة"
        },
        "enable_mode": {
          "title": "تفعيل ترجمة AI",
          "description": "اختر كيف تريد تمكين ترجمة AI.\n\"قواعد فقط\" سيطبّق القواعد التالية.\n\"المحرر المباشر فقط\" يسمح بتمكين الترجمة صفحة بصفحة من عرض المحرر المباشر.\n\"القواعد والمحرر المباشر\" سيستخدمان كلا الخاصيتين.",
          "disabled": "معطل",
          "rules": "قواعد فقط",
          "live_editor": "المحرر المباشر فقط",
          "all": "القواعد والمحرر المباشر"
        },
        "rule_application": {
          "description": "طبّق ترجمة AI على المحتوى الثابت أو الديناميكي أو كليهما",
          "title": "التطبيق على المحتوى",
          "all": "كل المحتوى",
          "static": "المحتوى الثابت",
          "dynamic": "المحتوى الديناميكي"
        },
        "website_topic": {
          "title": "موضوع الموقع",
          "placeholder": "مطعم سوشي...",
          "description": "عرّف موضوع موقعك لجودة ترجمة أفضل (مثلاً: قانوني، مطعم سوشي، متجر إلكتروني لقطع الدراجات...)\nيرجى إدخال موضوع الموقع بالإنجليزية."
        },
        "apply_to_urls": {
          "title": "التطبيق على عناوين URL",
          "description": "حدد عناوين URL محددة تريد تطبيق ترجمة AI عليها",
          "all_urls": "جميع عناوين URL",
          "selected_urls": "عناوين URL محددة",
          "label": "العنوان لتطبيقه",
          "placeholder": "العنوان لتطبيقه",
          "wildcard": "الرمز البدل",
          "regex": "التعبير العادي",
          "add": "إضافة جديد",
          "expression": "نوع التعبير"
        },
        "apply_languages": {
          "title": "التطبيق على اللغات",
          "description": "حدد لغة معينة تريد تطبيق ترجمة AI عليها",
          "all_languages": "جميع اللغات",
          "selected_languages": "لغات محددة",
          "placeholder": "اختر لغات...",
          "feedback": "يجب اختيار لغة واحدة على الأقل"
        },
        "formality": {
          "title": "الرسمية",
          "description": "حدد مستوى الرسمية في الترجمات، قد يكون مهماً للجمهور والسياق.\n\"محايد\" يحاول الحفاظ على رسمية المحتوى الأصلي.\n\"رسمي\" مخصص للمحتوى المهني أو التجاري أو القانوني (مثل استخدام الضمائر الرسمية مثل \"usted\" في الإسبانية).\n\"غير رسمي\" مخصص للمحتوى غير الرسمي والمحادثات (مثل استخدام \"tú\" في الإسبانية).",
          "neutral": "محايد",
          "formal": "رسمي",
          "informal": "غير رسمي"
        },
        "sentence_structure": {
          "classic": "كلاسيكي",
          "short": "جمل قصيرة ومباشرة",
          "detailed": "جمل مفصلة وشرحية",
          "title": "بناء الجملة",
          "description": "عرّف تفضيل نمط الكتابة."
        },
        "content_purpose": {
          "marketing": "تسويق/ترويجي (نقاشي وجذاب)",
          "technical": "تقني/تعليمي (واضح ودقيق وموجّه للعمل)",
          "support": "دعم العملاء (متعاطف ومفيد وطمأن)",
          "legal": "قانوني/امتثال (دقيق ورسمي وغير مبهم)",
          "educational": "تعليمي (واضح ومنظم وسهل الوصول)",
          "other": "أخرى (بالإنجليزية)",
          "title": "غرض المحتوى",
          "description": "عرّف الغرض الوظيفي للمحتوى الذي يتم ترجمته.",
          "other_placeholder": "صفّ الغرض..."
        },
        "target_audience": {
          "title": "الجمهور المستهدف",
          "description": "تحديد الجمهور المقصود للمحتوى المترجم (بالإنجليزية).",
          "placeholder": "على سبيل المثال، الآباء الناطقون بالإسبانية، ومسؤولو الخصوصية في الاتحاد الأوروبي"
        },
        "override_default_translations": {
          "title": "تجاوز الترجمة الافتراضية",
          "description": "في حال تعيينه على نعم، سيجبر هذا الخيار المحتوى على الترجمة عبر AI (لينغويز AI) حتى لو تمت ترجمته مسبقًا عبر ترجمة سحابة AI (نموذج الترجمة الافتراضي)."
        },
        "force_replace_before": {
          "title": "إعادة الترجمة بالذكاء الاصطناعي",
          "description": "أعِد الترجمة بالذكاء الاصطناعي لأي محتوى تمت ترجمته به قبل التاريخ المحدد، مثل المحتوى الذي تُرجم بنموذج أقدم. ستتم إعادة الترجمة عند الزيارة التالية للصفحات المشمولة وفقًا للقواعد، وستُستخدم أرصدة الذكاء الاصطناعي الخاصة بك.",
          "before_date": "قبل تاريخ"
        },
        "model": {
          "current": "الحالي",
          "title": "النموذج",
          "description": "اختر نموذج الترجمة الذي تريد استخدامه",
          "load_error": "تعذّر تحميل النماذج المتاحة. يرجى المحاولة مرة أخرى لاحقاً.",
          "thinking_warning": "يستخدم هذا النموذج مستوى عالياً من التفكير المنطقي (\"تفكير\") وسيستهلك رموزاً أكثر بكثير لكل ترجمة."
        },
        "override_manual_and_selected": {
          "no_default": "لا (افتراضي)",
          "title": "تجاوز الترجمات اليدوية والمحددة",
          "description": "افتراضيًا، تبقى الترجمة التي عدّلتها يدويًا معروضة على موقعك دائمًا، حتى بعد إنشاء ترجمة محسّنة بالذكاء الاصطناعي. اختر «نعم» لعرض الترجمة المحسّنة بالذكاء الاصطناعي بدلًا منها. تبقى ترجماتك اليدوية محفوظة ويمكنك الرجوع إليها في أي وقت. ينطبق هذا أيضًا عند إعادة ترجمة الصفحات للحصول على ترجمات جديدة، إذ سيستخدم أحدث ترجمة تلقائيًا."
        }
      },
      "message": {
        "save_success": "من المحتوى المترجم حالياً، يُقدّر عدد الصفحات التي سيتم تحسينها بترجمة AI بحوالي {{ai_affected_urls}}.",
        "save_success_only": "تم حفظ الإعدادات بنجاح."
      }
    },
    "pricing": {
      "plan": {
        "title": "اطلب حصة ترجمة AI",
        "buy_button": "اشترِ باقة ترجمة AI"
      },
      "modal": {
        "title": "تأكيد تغيير الخطة",
        "description": "هل أنت متأكد أنك تريد تغيير خطة ترجمة AI؟",
        "button_cancel": "إلغاء",
        "button_confirm": "تأكيد",
        "loading": "يرجى الانتظار...",
        "amount": "المبلغ",
        "credit": "الرصيد",
        "total_due": "الإجمالي المستحق"
      },
      "comparison": {
        "title": "ترجمة Google Cloud AI\nمقابل ترجمة Linguise AI",
        "list": {
          "0": {
            "google": "ترجمات سريعة وموثوقة",
            "linguise": "التعامل مع التعابير الإصطلاحية والتقنية"
          },
          "1": {
            "google": "ترجمة فورية لجميع صفحات الموقع",
            "linguise": "توليد الترجمات في الخلفية"
          },
          "2": {
            "google": "أفضل جودة وسعر منخفض",
            "linguise": "جودة مثالية وسعر مناسب"
          },
          "3": {
            "google": "الأنسب للمواقع الكبيرة أو الميزانية المحدودة",
            "linguise": "الأفضل للمواقع التي تتطلب جودة ترجمة مثالية"
          },
          "4": {
            "google": "سياق الصفحة للترجمة",
            "linguise": "سياق الصفحة والموقع للترجمة"
          }
        }
      },
      "botom_banner": {
        "title": "اختبر دقة ترجمة لا مثيل لها مع",
        "sub_title": "الجديد: ترجمة Linguise AI",
        "description": "تُعزز Linguise خدمات الترجمة التلقائية لديها بإطلاق ترجمة Linguise AI، خيار قوي جديد يستخدم أحدث نماذج الذكاء الاصطناعي المُحسّنة للترجمة (نماذج Llama الأحدث). يوفر هذا الخيار لمطوّري المواقع والوكالات مستوى أعلى من جودة الترجمة، مثالي للمشاريع التي تتطلب الكمال. تُكمل ترجمة Linguise AI الترجمة الحالية المقدمة عبر Google Cloud AI، لتمنحك مرونة ودقة أكبر."
      }
    },
    "success": {
      "tab_title": "شكراً لشراء خطة ترجمة AI!",
      "title": "شكراً لشراء خطة ترجمة AI!",
      "subtitle": "تم شراء خطة ترجمة AI بنجاح!",
      "message": "يمكنك إدارة خطة ترجمة AI من صفحة إعدادات ترجمة AI.",
      "home": "إدارة ترجمة AI"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "الاسم",
        "description": "اسم حساب الفاتورة"
      },
      "phone": {
        "title": "الهاتف",
        "description": "هاتف حساب الفاتورة"
      },
      "email": {
        "title": "البريد الإلكتروني",
        "description": "بريد حساب الفاتورة الإلكتروني"
      },
      "address": {
        "title": "العنوان",
        "description": "عنوان حساب الفاتورة",
        "city": "المدينة",
        "country": "الدولة",
        "address1": "العنوان 1",
        "address2": "العنوان 2",
        "postal": "الرمز البريدي",
        "state": "الولاية"
      },
      "tax": {
        "title": "الرقم الضريبي"
      }
    }
  },
  "checkouts": {
    "header": "الدفع",
    "payment_method": "اختر طريقة الدفع",
    "stripe_card": "بطاقة الائتمان (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "أدخل عنوان فاتورة جديد",
      "existing": "استخدم العنوان الحالي"
    },
    "pay_stripe": "تأكيد والدفع",
    "terms": "بالتأكيد على اشتراكك، فإنك تسمح لـLinguise بتحميلك مقابل المدفوعات المستقبلية وفقاً لشروطنا. يمكنك دائماً إلغاء اشتراكك.",
    "coupon": {
      "title": "هل لديك قسيمة؟",
      "placeholder": "أدخل رمز القسيمة هنا",
      "apply": "تطبيق",
      "percent": ".خصم {{0}}%"
    },
    "add_new": "إضافة جديد",
    "use_existing": "استخدم وسيلة الدفع الحالية",
    "recurring": {
      "month_single": "تُحاسَب شهرياً",
      "month_many": "تُحاسَب كل {{count}} أشهر",
      "year_single": "تُحاسَب سنوياً",
      "year_many": "تُحاسَب كل {{count}} أعوام",
      "day_single": "تُحاسَب يومياً",
      "day_many": "تُحاسَب كل {{count}} أيام",
      "week_single": "تُحاسَب أسبوعياً",
      "week_many": "تُحاسَب كل {{count}} أسابيع"
    },
    "add_new_no_stripe": "إضافة بطاقة جديدة",
    "summary": {
      "title": "الملخص",
      "subtotal": "الإجمالي",
      "total": "المجموع"
    }
  },
  "dashboard": {
    "main": {
      "title": "لوحة التحكم"
    },
    "statistics": {
      "main_title": "إحصائيات آخر 30 يوماً",
      "characters": "الأحرف المترجمة",
      "words": "الكلمات المترجمة",
      "bandwidth": "نطاق الإدخال",
      "request": "الطلبات",
      "page_views": "مشاهدات الصفحات لكل لغة (آخر 30 يوماً)",
      "multilingual_views": "مشاهدات الصفحات متعددة اللغات (آخر 30 يوماً)",
      "most_page_viewed": "أكثر 20 صفحة مشاهدة (آخر 30 يوماً)",
      "no_data_yet": "لا تتوافر بيانات حتى الآن",
      "th_language": "اللغة",
      "th_page_views": "المشاهدات",
      "real_visitors": "الزوار الفعليون",
      "crawler": "زاحف الويب"
    },
    "planHints": {
      "subscribeButton": "اشترك",
      "upgradeButton": "رقِّ",
      "usedWords": "أنت تستخدم حالياً {words_used} كلمة",
      "noPlan": "لم يُفعَّل أي خطة لهذا النطاق. اشترك في خطة وابدأ ترجمة موقعك",
      "noPlanShopify": "لم يُفعَّل أي خطة لهذا النطاق. اشترك في خطة من لوحة تحكم Shopify وابدأ ترجمة موقعك",
      "trialUsage": "أنت تستخدم حالياً {words_used} كلمة من أصل {words_allowed} كلمة مضمَّنة في خطة التجربة.",
      "trialEnds": "تُفعَّل تجربة الشهر الأول حتى تاريخ {trial_ends}.",
      "subscribeMessage": "اشترِ قبل انتهائها للحفاظ على ترجمة موقعك",
      "subscribeMessageShopify": "اشترِ من لوحة تحكم Shopify قبل انتهائها للحفاظ على ترجمة موقعك",
      "trialReachedLimit": "لقد بلغت الحد الأقصى للكلمات المترجمة في فترة التجربة.\nاشترك في أحد خططنا للاستمرار في ترجمة موقعك.",
      "paidUsage": "لقد استخدمت {words_used} / {words_allowed} كلمة مترجمة في خطتك.",
      "paidReachedLimit": "لقد بلغت الحد الأقصى للكلمات المترجمة في الخطة الحالية.\nرقِّ خطةك للاستمرار في ترجمة محتوى موقعك.",
      "trialOfferedUsage": "أنت تستخدم حالياً {words_used} كلمة من أصل {words_allowed} كلمة مضمَّنة في خطة التجربة.(بما في ذلك {free_words} كلمة مُهدى)",
      "paidOfferedUsage": "لقد استخدمت {words_used} / {words_allowed} كلمة مترجمة في خطتك.(بما في ذلك {free_words} كلمة مُهدى)",
      "noPlanExtra": "يرجى ملاحظة أن النطاقات غير النشطة وبياناتها تُحذَف تلقائياً بشكل دوري.",
      "planRecommended": "بناءً على حجم الترجمة الحالي لديك، الخطة الموصى بها هي:",
      "planMaximumWords": "{{words}} كلمة",
      "notHaveTranslatedWords": "لم تقم بأي ترجمة حتى الآن"
    },
    "translationSetup": {
      "kicker": "إعداد النطاق الفرعي",
      "title": "التحقق من إعداد الترجمة",
      "description": "راجع DNS والمضيفات المترجمة والوصول إلى الموقع الأصلي وحدود الحساب.",
      "starting": "جارٍ التحقق...",
      "button": "التحقق من الإعداد",
      "viewLatest": "عرض أحدث نتيجة",
      "viewCurrent": "عرض الفحص الحالي",
      "runAgain": "إعادة الفحص",
      "viewDetails": "عرض التفاصيل",
      "hideDetails": "إخفاء التفاصيل",
      "error": "تعذر التحقق من الإعداد",
      "allPassed": "اجتازت جميع الفحوصات",
      "setupNeedsAttention": "الإعداد يحتاج إلى انتباه",
      "setupNeedsAttentionDescription": "فشل فحص واحد أو أكثر. راجع العناصر أدناه أو تواصل مع دعم Linguise.",
      "lastChecked": "آخر فحص {{time}}",
      "domainOwnership": "ملكية النطاق",
      "domainOwnershipDescription": "تم العثور على سجل التحقق",
      "domainOwnershipFailure": "تعذر التحقق من سجل ملكية DNS.",
      "translatedHosts": "المضيفات المترجمة",
      "translatedHostsDescription": "تم فحص {{count}} من مضيفات اللغات",
      "translatedHostsFailure": "سجل CNAME واحد أو أكثر للغات غير صحيح.",
      "subdomainPage": "صفحة النطاق الفرعي",
      "subdomainPageDescription": "تقبل {{count}} من الصفحات المترجمة HTTPS",
      "subdomainPageFailure": "فشل اتصال TLS عند فتح صفحة مترجمة واحدة أو أكثر.",
      "originalSite": "الموقع الأصلي",
      "originalSiteDescription": "فحوصات DNS وTLS والاستجابة للموقع الأصلي",
      "originalSiteFailure": "فشل فحص DNS أو TLS أو الاستجابة للموقع الأصلي.",
      "documentationAdvice": {
        "dns": "راجع إعداد DNS",
        "tls": "راجع إعداد HTTPS",
        "origin": "راجع إعداد الموقع الأصلي",
        "diagnostic": "راجع خطوات استكشاف الأخطاء وإصلاحها"
      },
      "evidence": {
        "originDns": "DNS الأصلي",
        "originTls": "TLS الأصلي",
        "originHttp": "استجابة الموقع الأصلي",
        "observedTargets": "الأهداف المرصودة",
        "recordCount": "السجلات التي تم العثور عليها",
        "addressCount": "العناوين التي تم العثور عليها",
        "statusCode": "حالة HTTP",
        "redirect": "إعادة التوجيه",
        "expiresAt": "انتهاء صلاحية الشهادة",
        "raw": "{{key}}",
        "noValue": "لا توجد قيمة"
      },
      "checkerError": "تعذر إكمال بعض الفحوصات.",
      "coreLocation": "تم الفحص من {{location}}",
      "status": {
        "queued": "في قائمة الانتظار",
        "running": "جارٍ التنفيذ",
        "completed": "مكتمل",
        "failed": "فشل",
        "passed": "اجتاز",
        "warning": "تحذير",
        "unknown": "غير معروف",
        "skipped": "تم التخطي",
        "not_applicable": "لا ينطبق"
      }
    },
    "throttling": {
      "title": "حد الترجمة",
      "description": "حدود استخدام مؤقتة",
      "unavailable": "حدود الترجمة المؤقتة غير متاحة",
      "window": "{{used}} / {{max}} كلمة",
      "resetsIn": "يُعاد الضبط خلال {{time}}",
      "throttled": "تم إيقاف الترجمة مؤقتًا",
      "throttledDescription": "تم بلوغ حد استخدام مؤقت. ستُستأنف الترجمة عند إعادة ضبط هذه الفترة."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "الخطوة {{step}} من {{total}}",
      "doneLabel": "تم! يمكنك البدء في الترجمة الآن!",
      "finish": {
        "title": "",
        "description": "هذا هو مفتاح API الذي ستستخدمه في موقعك"
      },
      "instructions": "تعليمات التثبيت",
      "domainSetting": "إعدادات النطاق",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "برنامج PHP",
        "wizardWordpressStep1": "1. ثبِّت الـ ",
        "wizardWordpressStep2": "\n 2. في إعدادات المكوِّن، انسخ وأدخل مفتاح API الخاص بك\n",
        "wizardWordpressStep3": "3. أصبحت جاهزاً للترجمة\n\n",
        "wizardWordpressStep4": "للحصول على تعليمات مفصَّلة، رجاءً اطلع على وثائقنا: ",
        "wizardJoomlaStep1": "1. رابط حزمة Joomla: ",
        "wizardJoomlaStep2": "\n2. في إعدادات الامتداد، انسخ وأدخِل مفتاح API الخاص بك",
        "wizardJoomlaStep3": "3. في إعدادات الوحدة، حدّد اللغات التي ترغب في عرضها، وأدرج الوحدة حيث تحتاجها.",
        "wizardJoomlaStep4": "\n4. أصبحت جاهزًا للترجمة\n\n",
        "wizardPhpStep1": "1. نزِّل سكريبت PHP الخاص بنا من هنا ",
        "wizardPhpStep2": "\n2. اتبع تعليمات التثبيت في صفحة وثائقنا هنا ",
        "wizardPhpStep3": "\n3. أضف الوحدة إلى صفحاتك.",
        "wizardPhpStep4": "\nانسخ الكود التالي وألصقه في قسم head من صفحتك HTML، وسيعرض وحدة المُبدِّل تلقائيًا\n",
        "dispatchStep1": "لقد أرسلنا البيانات المطلوبة بنجاح إلى ملحق Linguise، يمكنك الآن إغلاق النافذة التالية.",
        "dispatchStep2": "في حال كان الرمز مفقودًا عند إغلاق هذه النافذة، رجاءً انسخ الرمز التالي:",
        "dispatchStep3": "يمكنك أيضًا نسخ هذا المقتطف لتمكين مُبدِّل الأعلام لدينا تلقائيًا",
        "wizardOtherStep1": "اتبع التعليمات أدناه لتثبيت Linguise على نطاقك.\n",
        "wizardOtherStep2": "انسخ الكود التالي وألصقه في قسم head من صفحتك HTML؛ وسيعرض وحدة المُبدِّل تلقائيًا.\n"
      },
      "trialAlreadyUsed": "يبدو أنك استخدمت بالفعل النسخة التجريبية المجانية، لذا تحتاج إلى الحصول على حصة ترجمة\nيرجى الاشتراك في خطة أو التواصل معنا إذا كنت بحاجة إلى تمديد نسختك التجريبية.",
      "usefulLinks": "روابط مفيدة للبدء",
      "linkDocumentation": "التوثيق",
      "linkExtensionDl": "تحميل الامتداد",
      "linkSubscribe": "اشترك في خطة الآن",
      "linkDashboard": "انتقل إلى لوحة التحكم",
      "exclusion": {
        "title": "أسماء الشركات والمنتجات",
        "description": ""
      },
      "finishButton": "أنهِ الإعداد",
      "subdomains": "النطاقات الفرعية",
      "subdomain_setup": "إعداد النطاق",
      "subdomain_auto_setup": "اربط DNS تلقائيًا",
      "subdomain_manual_setup": "أضف إدخالات DNS بنفسي",
      "subdomain_skip": "أجّل ذلك لاحقًا",
      "auto_subdomains_info": "يتطلِّب منشئ موقعك CMS تكوين DNS لضبط اللغات لكل نطاق فرعي (مثال: ar.domain.com).",
      "auto_subdomains_info_2": "يمكنك القيام بذلك تلقائيًا باستخدام Entri. ما عليك سوى النقر على زر «اربط DNS تلقائيًا» لبدء الاتصال بمدير DNS الخاص بك وإضافتها عبر Entri.",
      "auto_subdomains_info_manual": "أو يمكنك تكوين نطاقك يدويًا بالنقر على زر «أضف إدخالات DNS بنفسي».",
      "breadcrumbs": {
        "step1": "الخطوة 1: النطاق، نظام إدارة المحتوى واللغات",
        "step2": "الخطوة الثانية: نظام أسماء النطاقات للغة",
        "step3": "الخطوة {{step}}: تعليمات التثبيت"
      }
    },
    "form": {
      "urls": {
        "dash": "شَرْطَة -",
        "underscore": "شَرْطَة سُفلية _",
        "title": "ترجمة عناوين URL",
        "description": "هل ترغب في الترجمة في جميع الصفحات",
        "char_description": "الحرف المستخدم لاستبدال الرموز غير المسموح بها في عناوين URL",
        "advertisement_title": "⚠ لقد عيَّنت عددًا كبيرًا من اللغات.\n",
        "advertisement": "ننصح عادةً ببدء ترجمة المواقع بعدد قليل من اللغات أولًا، حتى تحصل على فكرة عن عدد كلمات موقعك. وهذا أفضل أيضًا لتحسين محركات البحث، إذ تزحف روبوتات Google بسرعة أكبر عبر صفحاتك إذا كانت الصفحات أقل عددًا في البداية. بعد أسبوع يمكنك إضافة المزيد من اللغات وهكذا."
      },
      "url": {
        "title": "الرابط",
        "description": "ضع رابط نطاقك الرئيسي مبدوءًا بـ http:// أو https://",
        "placeholder": "رابط النطاق",
        "advertisement_http": {
          "title": "أنت لا تستخدم بروتوكول https",
          "description": "يرجى التحقق مما إذا كان نطاقك لا يستخدم فعليًا بروتوكول https، والمُستَحسن حاليًا."
        },
        "advertisement_www": {
          "title": "نطاقك الفرعي ليس www",
          "description": "في أغلب الأحيان يكون النطاق الفرعي الافتراضي هو www (مثل https://www.mydomain.com). قد لا يكون حالك كذلك، لكن رجاءً تأكد مرة أخرى أن النطاق الذي تريد إضافته هو الصحيح."
        },
        "invalid_url": {
          "line1": "تعذَّر علينا العثور على نطاقك. يرجى التحقق من أن نطاقك متاح للعامة عبر الإنترنت وأنه لا يُعاد توجيهه إلى موقع آخر.",
          "line2": "إذا كنت متأكدًا من أن نطاقك متاح، يمكنك تخطي التحقق من النطاق والنقر على زر «الخطوة التالية» مرة أخرى",
          "contact": "في أي حال يمكنك التواصل معنا على",
          "force": "تخطي التحقق من النطاق"
        },
        "invalid_subdomain_url": "هذا الرابط غير مسموح به. يجب أن تكون النطاقات الفرعية على النحو التالي: https://www.domain.tld أو https://domain.tld بدون كلمة subdirectory."
      },
      "account": {
        "title": "الحساب",
        "description": "اختر حسابًا لتعيين هذا النطاق له",
        "placeholder": "اختر حسابًا...",
        "feedback": "يجب أن تختار حسابًا"
      },
      "platform": {
        "title": "المنصة",
        "description": "يرجى اختيار منصة موقعك حسب اسم CMS.",
        "learn": "تعرّف على كيفية اختيارها",
        "placeholder": "ابحث عن المنصة حسب اسم CMS...",
        "info": {
          "title": "⚠ تمت إضافة هذه المنصة مؤخرًا.\n",
          "desc": "منشئ المواقع هذا مدعوم من Linguise، رغم أنه أُضيف مؤخرًا. إذا واجهت أي مشكلة، رجاءً تواصل معنا عبر البريد الإلكتروني للدعم المباشر:"
        },
        "description_read_only": "المنصة التي يستخدمها موقعك",
        "feedback": "يجب أن تختار منصة"
      },
      "language": {
        "title": "اللغة",
        "description": "اختر اللغة الأساسية لموقعك",
        "placeholder": "اختر لغة...",
        "feedback": "يجب أن تختار لغة",
        "description_read_only": "اللغة الأساسية لموقعك"
      },
      "token": {
        "title": "مفتاح API",
        "description": "هذا هو مفتاح API الذي يجب نسخه إلى موقعك",
        "copy": "انسخ إلى الحافظة",
        "reset": "إعادة تعيين مفتاح API",
        "reset_confirm": "يرجى تأكيد إعادة تعيين مفتاح API"
      },
      "languages": {
        "title": "لغات الترجمة",
        "description": "اختر اللغات التي ترغب أن يكون موقعك قابلًا للترجمة إليها",
        "placeholder": "اختر لغات...",
        "feedback": "يجب أن تختار لغة"
      },
      "defaultRules": {
        "title": "القواعد الافتراضية",
        "description": "وضعنا مجموعة من القواعد التي يجب استخدامها لتحسين الترجمة وتجنّب ترجمة محتوى غير مرغوب فيه، مثل لوحة تحكم WordPress.\nيمكنك حذف أو تعديل هذه القواعد لاحقًا إذا رغبت."
      },
      "disallow_deletion": "لا يمكنك حذف نطاق به اشتراك نشط",
      "delete_confirm": "يرجى تأكيد حذف النطاق",
      "delete": "احذف النطاق",
      "dynamic": {
        "title": "ترجمة المحتوى الديناميكي",
        "description": "سيتم ترجمة المحتوى الديناميكي الذي يتم إنشاؤه عبر JavaScript وطلبات AJAX (هذا الخيار سيزيد من استخدامات الترجمة لديك)"
      },
      "partial_translations": {
        "title": "السماح بالترجمة الجزئية",
        "description": "إذا وصلت حسابك إلى حصة الترجمة القصوى وما زالت الصفحة بحاجة إلى ترجمة، يمكن لـ Linguise الاستمرار في عرض الصفحة بالمحتوى الذي تمت ترجمته بالفعل.\nلكن ستبقى أجزاء من الصفحة غير مترجمة حتى تُحدِّث حصتك.\n\nرغم أن كمية صغيرة من المحتوى غير المترجم عادةً لا تُضرُّ بتحسين محركات البحث، إلا أن السماح بكمية كبيرة من المحتوى غير المترجم قد يؤثر سلبًا في تجربة المستخدم.\nلمعالجة ذلك، يمكنك تحديد عتبة لنسبة المحتوى غير المترجم المسموح بها في الصفحة. إذا تجاوزت النسبة هذه العتبة، سيتم إعادة توجيه المستخدمين تلقائيًا إلى نسخة اللغة الأصلية للصفحة.",
        "never": "أبدًا"
      },
      "translate_error_pages": {
        "title": "ترجمة صفحات الأخطاء",
        "description": "يمكن لـ Linguise ترجمة جميع صفحات الأخطاء، لكن إذا كانت صفحة الخطأ تحتوي على محتوى ديناميكي مثل عنوان IP أو معرف الطلب، يجدر بك تجنب ترجمتها.",
        "not_found_page": {
          "title": "ترجمة صفحة 404"
        },
        "error_page": {
          "title": "ترجمة صفحات الأخطاء الأخرى"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "تم العثور على نطاق موجود",
          "description": "تم العثور على نطاق موجود لهذا المستخدم، هل ترغب في استخدامه؟"
        }
      },
      "search_tl": {
        "title": "البحث في الترجمات",
        "description": "فعِّل البحث في الترجمات لمنصة موقعك (تجريبي، سيزيد هذا الخيار من استخدامات الترجمة لديك)"
      },
      "shopify_promo": {
        "info": "خبر سار! لدينا الآن تطبيق أصلي لمنصة Shopify يمكنك تثبيته من متجر تطبيقات Shopify.",
        "hyperlink": "انقر هنا وقم بتثبيت Linguise من التطبيق.",
        "next_btn": "انتقل إلى متجر Shopify لتثبيت التطبيق",
        "info_legacy": "خبر سار! لدينا الآن تطبيق أصلي لمنصة Shopify يمكنك تثبيته من متجر تطبيقات Shopify.",
        "description_legacy": "اختر منصة \"Shopify\" بدلاً من \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "خبر سار! لدينا الآن تطبيق أصلي لمنصة Wix يمكنك تثبيته من Wix App Market.",
        "hyperlink": "انقر هنا وقم بتثبيت Linguise من التطبيق.",
        "next_btn": "انتقل إلى Wix App Market لتثبيت التطبيق",
        "info_legacy": "خبر سار! لدينا الآن تطبيق أصلي لمنصة Wix يمكنك تثبيته من Wix App Market.",
        "description_legacy": "اختر منصة \"Wix\" بدلاً من \"Wix Legacy\""
      },
      "ai_disallow_deletion": "لا يمكنك حذف هذا المجال بينما لا تزال حصة الذكاء الاصطناعي متاحة.\n\nيرجى الاتصال بفريق الدعم الخاص بنا إذا كنت تريد حذف هذا النطاق على",
      "language_removal": {
        "card": {
          "title": "حذف ترجمات اللغات المحذوفة",
          "description": "تمت إزالة هذه اللغات من موقعك، لكن ترجماتها المخزنة ما زالت تُحتسب ضمن حصتك. احذفها لاستعادة الكلمات إلى رصيدك.",
          "button": "حذف الترجمات"
        },
        "hint": "تُعاد الكلمات المستخدمة إلى رصيدك. يمكنك إجراء ذلك مرة كل {{days}} يومًا لكل موقع.",
        "modal": {
          "title": "حذف الترجمات؟",
          "intro": "سيتم حذف هذه الترجمات نهائيًا:",
          "warning": "لا يمكن التراجع عن ذلك. ستُعاد الكلمات المستخدمة إلى رصيدك، وقد يستغرق ذلك بضع دقائق.",
          "limit": "يمكنك إجراء ذلك مرة كل {{days}} يومًا لكل موقع.",
          "confirm": "حذف الترجمات"
        },
        "scheduled": "جارٍ حذف الترجمات وسيُحدّث رصيدك قريبًا.",
        "cooldown": "حُذفت الترجمات من هذا الموقع مؤخرًا. يمكنك حذفها مجددًا في {{date}}.",
        "latest_completed": {
          "title": "آخر عملية حذف مكتملة",
          "description": "راجع اللغات المحذوفة والكلمات المعادة إلى رصيدك.",
          "languages": "اللغات المحذوفة",
          "words_returned": "الكلمات المعادة إلى رصيدك: {{words}}",
          "completed_at": "اكتمل في {{date}}"
        },
        "status": {
          "recent_title": "آخر حذف للترجمات",
          "recent_description": "تابع آخر عملية حذف وموعد إتاحة الحذف التالي.",
          "progress_title": "تقدم الحذف",
          "loading": "جارٍ التحقق من تقدم الحذف...",
          "unavailable": "تعذر تحميل تقدم الحذف. حدّث الصفحة وحاول مجددًا.",
          "label": "الحالة",
          "pending": "في قائمة الانتظار",
          "processing": "قيد التنفيذ",
          "completed": "مكتمل",
          "failed": "فشل",
          "unknown": "الحالة غير متاحة",
          "percent": "اكتمل {{percent}}%",
          "current_stage": "الخطوة الحالية: {{stage}}",
          "processed": "تمت معالجة {{processed}} سجلًا",
          "processed_total": "تمت معالجة {{processed}} من {{total}} سجلًا",
          "requested_at": "طُلب في {{date}}",
          "started_at": "بدأ في {{date}}",
          "completed_at": "اكتمل في {{date}}",
          "cooldown_period": "يمكنك إجراء ذلك مرة كل {{days}} يومًا لكل موقع.",
          "cooldown_blocked": "لا يمكن بدء عملية حذف أخرى بعد.",
          "stage": {
            "queued": "في انتظار البدء",
            "processing": "قيد التنفيذ",
            "refund_summary": "جارٍ حساب الكلمات المعادة",
            "search_translations": "جارٍ حذف ترجمات البحث",
            "url_translations": "جارٍ حذف ترجمات عناوين URL",
            "translations": "جارٍ حذف الترجمات",
            "completed": "مكتمل",
            "failed": "فشل",
            "unknown": "قيد التنفيذ"
          }
        },
        "forbidden": "ليس لديك إذن بحذف الترجمات."
      }
    },
    "main": {
      "edit": "تعديل النطاق",
      "add": "إضافة نطاق",
      "wizard": "مرحبًا! معالج إنشاء نطاق جديد",
      "common": "النطاق"
    },
    "notice": {
      "broken_card": "تعذَّر علينا تجديد خطتك لـ {{url}} باستخدام وسيلة الدفع الحالية، يرجى تحديث بطاقة الدفع",
      "quota_reached": "لقد تم استنفاد حصة الترجمة الخاصة بك لـ {{url}}، يرجى الترقية لاستئناف ترجمة موقعك",
      "ai_no_subscription": "تتطلّب الترجمة بالذكاء الاصطناعي لـ {{url}} اشتراكًا نشطًا أو نسخة تجريبية نشطة. ستتوقف بدونه، يرجى الترقية للاستمرار",
      "important": "مهم",
      "quota_reached_button": "حدّث خطتك الآن",
      "broken_card_button": "حدّث بطاقة الدفع",
      "ai_no_subscription_button": "حدّث خطتك الآن",
      "quota_warning": "لقد وصلت حصة الترجمة الخاصة بك لـ {{url}} إلى {{throttling_used_percent}}%، وسيتم إعادة ضبطها خلال {{ttl}}",
      "locked": "النطاق {{url}} مقفل حاليًا للترحيل، ولا يزال بإمكانك الوصول إلى موقعك ولكن لا يمكنك تعديل أو إضافة ترجمات جديدة!"
    },
    "subdomains": {
      "config_ok": "تم تكوين DNS النطاقات الفرعية بشكل صحيح.",
      "config_invalid": "يتطلب DNS النطاقات الفرعية تكوينًا إضافيًا ليعمل.",
      "config_check": "جارٍ التحقق من تكوين DNS النطاقات الفرعية، يرجى الانتظار...",
      "entri_timeout": "أبلغت Entri أن انتهت مهلة نشر DNS النطاقات الفرعية، تحتاج إلى إعادة المحاولة أو يمكنك إجراؤها يدويًا.",
      "entri_process": "تمت إضافة DNS خاصتك عبر Entri وغالبًا ما يستغرق النشر 10-30 دقيقة (تطبيق جميع نطاقاتك الفرعية مثل ar.domain.com). إذا لم تنتهي التحقق بعد 24 ساعة، يمكنك الاتصال بفريق الدعم: support@linguise.com",
      "entri_ok": "جارٍ نشر DNS! في انتظار الاكتمال...",
      "infos": "يجب إضافة هذه الإدخالات إلى سجلات نطاق DNS لتفعيل الترجمة. انقر على زر التحقق عند الانتهاء. قد يستغرق نشر سجلات DNS بعض الوقت، لذا قد تحتاج إلى العودة بعد بضع دقائق أو ساعات.",
      "check": "تحقق من إعدادات نظام أسماء النطاقات (DNS)"
    },
    "subscription": {
      "next_payment_amount": "الرسوم القادمة",
      "next_payment_date": "تاريخ الدفعة التالية",
      "invoice": {
        "header": "سجل الفواتير",
        "date": "التاريخ",
        "amount_due": "المبلغ",
        "status": "الحالة",
        "actions": "الإجراءات",
        "description": "بمجرد توفر المعاملات، يمكنك رؤيتها هنا.",
        "status_text": {
          "draft": "مسودة",
          "failed": "فشلت",
          "open": "معلقة",
          "paid": "مدفوعة",
          "retrying": "إعادة محاولة",
          "uncollectible": "غير قابلة للتحصيل",
          "void": "ملغاة"
        },
        "view": "عرض",
        "empty": "لم يتم العثور على فواتير حديثة لهذه الاشتراك",
        "retry_payment": "إعادة المحاولة"
      },
      "next_cancellation": "تاريخ الإلغاء",
      "cancel": "إلغاء الاشتراك",
      "change_plan": "تغيير الخطة",
      "change": "تغيير",
      "suspend": "تعليق الدفع",
      "resume": "استئناف الاشتراك",
      "back": "رجوع",
      "save": "حفظ",
      "confirm_resume": "هل أنت متأكد من استئناف هذا الاشتراك؟",
      "confirm_cancel": "هل أنت متأكد من إلغاء هذا الاشتراك؟",
      "confirm_header": "هل أنت متأكد؟",
      "missing_status": "هذا الاشتراك مفقود",
      "not_found": "لم يتم العثور على اشتراك لهذا النطاق",
      "confirm_manual_retry": "هل أنت متأكد من إعادة محاولة هذه الدفعة؟",
      "no_payment_method": "غير معروف",
      "remove_billing": "إزالة",
      "shopify_maneged": "يتم إدارة هذا الاشتراك عبر Shopify. الرجاء إدارته من لوحة إدارة Shopify.",
      "unknown_plan": "خطة غير معروفة"
    }
  },
  "domain_listing": {
    "add": "إضافة موقع",
    "select": "اختر نطاقًا"
  },
  "editable": {
    "number": "رقم {{id}}"
  },
  "footer": {
    "about": "من نحن",
    "support": "الدعم"
  },
  "frontendEditor": {
    "main": "المحرر المباشر",
    "description": "المحرر المباشر يساعدك على تعديل الترجمات في موقعك مباشرة.",
    "button": "فتح المحرر المباشر",
    "language_selection": "اختيار لغة الترجمة",
    "video_label": "تعلم كيفية استخدام المحرر المباشر"
  },
  "general": {
    "403": {
      "tab_title": "عفوًا - خطأ 403",
      "title": "تم الرفض",
      "message": "يبدو أنك لا تمتلك صلاحية الوصول إلى هذه الصفحة.",
      "home": "العودة للصفحة الرئيسية"
    },
    "404": {
      "tab_title": "عفوًا - خطأ 404",
      "title": "الصفحة غير موجودة",
      "message": "يبدو أنك أخطأت الطريق. لا تقلق... يحدث ذلك للجميع. إليك نصيحة قد تعيدك للمسار.",
      "home": "العودة للصفحة الرئيسية"
    },
    "500": {
      "tab_title": "خطأ 500",
      "title": "خطأ داخلي في الخادم",
      "message": "لماذا لا تحاول تحديث الصفحة؟ أو يمكنك الاتصال بنا",
      "home": "العودة للصفحة الرئيسية"
    },
    "fields": {
      "alert": "بعض الحقول غير صحيحة، يرجى تصحيحها.",
      "invalid": "هذا الحقل غير صحيح",
      "phone_re": "رقم الهاتف غير صحيح",
      "phone_invalid": "رقم الهاتف غير صحيح",
      "email": "حقل البريد الإلكتروني غير صالح"
    },
    "table": {
      "no_data": "لا توجد بيانات هنا بعد..."
    },
    "saving": "جارٍ الحفظ...",
    "save": "حفظ",
    "save_and_quit": "حفظ وخروج",
    "invite": "دعوة",
    "cancel": "إلغاء",
    "yes": "نعم",
    "no": "لا",
    "nextStep": "الخطوة التالية",
    "loading": "يرجى الانتظار حتى يتم تحميل التطبيق",
    "goback": "رجوع",
    "manage": "إدارة",
    "delete": "حذف",
    "deleting": "جارٍ الحذف...",
    "confirm": "تأكيد",
    "unknown": "غير معروف",
    "hide": "يخفي",
    "show": "يعرض",
    "on": "على",
    "off": "عن",
    "default": "افتراضي"
  },
  "home": {
    "header": "الصفحة الرئيسية",
    "manage": "إدارة الاشتراك",
    "canceled": "مجدول للإلغاء",
    "activate_now": "فعل الآن",
    "activate_plan_now": "اشترك الآن",
    "upgrade_plan_now": "حدّث الخطة الآن",
    "trial_message_part_1": "أنت حاليًا في الخطة التجريبية،",
    "trial_message_part_2": "يمكنك تفعيل عضوية في أي وقت.",
    "add": "إضافة نطاق",
    "table": {
      "title": "النطاقات",
      "description": "قائمة نطاقاتك، انقر على النطاق لإدارة الترجمات"
    },
    "domains": {
      "empty": "ليس لديك أي نطاقات في هذا الحساب"
    },
    "accountsList": {
      "title": "الحسابات",
      "add": "إضافة حساب جديد",
      "name": "اسم الحساب"
    },
    "update_credit_card": "تحديث تفاصيل بطاقة الائتمان",
    "cancelling_subs": "الإلغاء في {{0}}",
    "resume_subscription": "استئناف الاشتراك",
    "shopify_managed": "تُدار بواسطة Shopify",
    "trial_ends_at": "ينتهي عند {{0}}",
    "free_trial": "تجربة مجانية",
    "no_subs": "لا يوجد اشتراك نشط"
  },
  "invoices": {
    "title": "الفواتير",
    "list": {
      "title": "قائمة الفواتير"
    },
    "table": {
      "customer": "العميل",
      "domain": "النطاق",
      "amountPaid": "المبلغ المدفوع",
      "status": "الحالة",
      "date": "التاريخ",
      "invoice": "الفاتورة",
      "pay": "دفع الفاتورة",
      "actions": "الإجراءات",
      "deleted_domain": "تم حذف النطاق",
      "plan_name": "الخطة",
      "action": "الإجراء"
    },
    "listPending": {
      "title": "قائمة الفواتير المعلقة"
    }
  },
  "language_settings": {
    "display": "عرض قائمة اللغات",
    "position": "الموضع",
    "display_help_text": "عرض العلم و/أو أسماء اللغات. يمكن أن يكون موضع محدد اللغات الافتراضي في أي مكان داخل المحتوى أو في موضع ثابت يبقى ثابتًا أو يتحرك أثناء التمرير",
    "side_by_side": "جنبًا إلى جنب",
    "dropdown": "قائمة منسدلة",
    "popup": "نافذة منبثقة",
    "flag": "العلم",
    "lang_name": "اسم اللغة",
    "lang_short_name": "الأسماء المختصرة",
    "positions": {
      "in_place": "في مكانه",
      "top_left": "أعلى اليسار",
      "top_left_no_scroll": "أعلى اليسار (بدون تمرير)",
      "top_right": "أعلى اليمين",
      "top_right_no_scroll": "أعلى اليمين (بدون تمرير)",
      "bottom_left": "أسفل اليسار",
      "bottom_left_no_scroll": "أسفل اليسار (بدون تمرير)",
      "bottom_right": "أسفل اليمين",
      "bottom_right_no_scroll": "أسفل اليمين (بدون تمرير)"
    },
    "lang_names_display": {
      "title": "عرض أسماء اللغات",
      "help_text": "في مُبدّل اللغات، اعرض أسماء اللغات بالإنجليزية أو باللغة الأصلية، مثل الفرنسية أو Français",
      "english": "الإنجليزية",
      "native_languages": "اللغات الأصلية"
    },
    "flag_shape": {
      "title": "أسلوب العلم",
      "help_text": "استخدم أيقونات أعلام svg دائرية أو مستطيلة",
      "round": "دائري",
      "rectangular": "مستطيل"
    },
    "english_flag_type": {
      "title": "نوع علم الإنجليزية",
      "help_text": "استخدم علم بريطانيا أو الولايات المتحدة للإنجليزية",
      "usa": "علم الولايات المتحدة",
      "great_britain": "علم بريطانيا"
    },
    "german_flag_type": {
      "title": "نوع علم الألمانية",
      "help_text": "استخدم علم النمسا أو ألمانيا للألمانية",
      "german": "علم ألمانيا",
      "austria": "علم النمسا"
    },
    "spain_flag_type": {
      "title": "نوع علم الإسبانية",
      "help_text": "استخدم علم المكسيك أو إسبانيا للإسبانية",
      "spanish": "علم إسبانيا",
      "mexico": "علم المكسيك",
      "peruvian": "علم البيرو"
    },
    "portugal_flag_type": {
      "title": "نوع علم البرتغالية",
      "help_text": "استخدم علم البرتغال أو البرازيل للبرتغالية",
      "portugal": "علم البرتغال",
      "brazil": "علم البرازيل"
    },
    "taiwanese_flag_type": {
      "title": "نوع علم التايوانية",
      "help_text": "استخدم علم تايوان أو الصين للتايوانية",
      "taiwanese": "علم تايوان",
      "chinese": "علم الصين"
    },
    "flag_border_radius": {
      "title": "نصف قطر الحدود للعَلم (px)",
      "help_text": "إذا كنت تستخدم شكل العلم المستطيل، يمكنك تطبيق نصف قطر حدود مخصص بالبيكسل"
    },
    "flag_width": {
      "title": "حجم العلم (px)",
      "help_text": "اختر حجم الأعلام بالبيكسل. هذا لا يغيّر وزن الصورة لأنها بصيغة .svg"
    },
    "lang_color": {
      "color_title": "لون اسم اللغة",
      "color_help_text": "اختر لون نص افتراضي لأسماء اللغات",
      "hover_color_title": "لون اسم اللغة عند المرور",
      "hover_color_help_text": "اختر لون نص عند المرور لأسماء اللغات",
      "color_popup_title": "لون اللغة في النافذة المنبثقة",
      "color_popup_help_text": "لون عنوان اللغة في مناطق النافذة المنبثقة أو القائمة المنسدلة",
      "hover_color_popup_title": "لون اللغة عند المرور في النافذة",
      "hover_color_popup_help_text": "اختر لون نص عند المرور لعنوان اللغة في النافذة المنبثقة أو القائمة المنسدلة"
    },
    "flag_box_shadow": {
      "shadow_title": "ظل صندوق العلم",
      "shadow_help_text": "لون وحجم الظل لأعلامك",
      "hover_shadow_title": "ظل صندوق العلم عند المرور",
      "hover_shadow_help_text": "لون وحجم الظل لأعلامك عند المرور",
      "shadow_h_offset": "إزاحة الظل الأفقية (px)",
      "shadow_v_offset": "إزاحة الظل الرأسية (px)",
      "shadow_blur": "ضبابية الظل (px)",
      "shadow_spread": "انتشار الظل (px)",
      "shadow_color": "لون الظل"
    },
    "order": "ترتيب اللغات",
    "language_order_help": "ترتيب اللغات الذي سيظهر في مُبدّل اللغات. يمكنك السحب والإفلات لإعادة الترتيب.",
    "order_reset": "إعادة الترتيب",
    "language_order_dragdrop": "يمكنك السحب والإفلات لإعادة ترتيب اللغات.",
    "popup_lang_name": "اسم اللغة في النافذة",
    "preview": "معاينة اللغة"
  },
  "link": {
    "form": {
      "original": {
        "title": "المصدر الأصلي",
        "description": "أضف رابط URL الأصلي واستبدل به أدناه حسب اللغة لترجمته",
        "srcset_description": "أنت تُحرّر رابط صورة. تأكد من قراءة التوثيق، خاصة إذا كنت تستخدم srcset أو لا تعرف ما هو",
        "link": "الرابط",
        "match_link": "وضع المطابقة",
        "match_exact": "تطابق تام",
        "match_wildcard": "بدل",
        "match_regex": "تعبير منتظم"
      },
      "alternative_languages": {
        "title": "الروابط المراد استبدالها",
        "description": "استبدل روابط الوسائط والروابط الخارجية في جميع صفحاتك حسب اللغة…",
        "link": "الرابط المراد استبداله"
      },
      "error": {
        "atLeastOne": "يرجى إضافة ترجمة واحدة على الأقل.",
        "url": "عنوان URL غير صالح",
        "extension": "يجب أن يحتوي الرابط على امتداد، ولكن لا يمكن أن يكون .html أو .php. كما يجب ألا يحتوي الرابط على مسار لغة مثل \"/fr\"",
        "regex": "الترميز المنتظم غير صالح",
        "wildcard": "الرابط البديل يحتوي على بروتوكول غير صالح"
      }
    },
    "main": {
      "parent": "الروابط",
      "edit": "تعديل الرابط"
    }
  },
  "links": {
    "title": "إدارة روابط الوسائط والروابط الخارجية",
    "description": "إدراج وتعديل روابط الوسائط أو الروابط الخارجية لموقعك.",
    "add": "إضافة رابط",
    "delete": "حذف الرابط",
    "table": {
      "original": "الأصلي",
      "language": "اللغة",
      "translation": "الترجمة",
      "action": "الإجراء",
      "delete_confirm": "يرجى تأكيد حذف الرابط"
    }
  },
  "members": {
    "header": "الأعضاء",
    "invite": "دعوة عضو جديد",
    "modal": {
      "inviteHeader": "دعوة عضو جديد",
      "editHeader": "تعديل العضو",
      "detachHeader": "إلغاء إرفاق العضو",
      "detachBody": "هل أنت متأكد من أنك تريد إلغاء إرفاق الععضو من هذا الحساب؟",
      "selfDetachBody": "هل أنت متأكد من رغبتك في إلغاء إرفاق نفسك من إدارة هذا الحساب؟ لن تتمكن بعدها من الوصول إلى أي من البيانات المتعلقة بالحساب."
    },
    "table": {
      "title": "قائمة الأعضاء",
      "description": "أدوار الأعضاء والوصول إلى النطاقات",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "websites": "المواقع",
      "languages": "اللغات",
      "role": "الدور",
      "status": "الحالة",
      "resendInvite": "إعادة الإرسال",
      "inviteSent": "تم إرسال الدعوة",
      "actions": "الإجراءات",
      "edit": "تعديل",
      "detach": "إلغاء الإرفاق",
      "empty": "ليس لديك أعضاء حتى الآن",
      "all_website": "جميع المواقع واللغات",
      "roles": {
        "admin": "مسؤول",
        "manager": "مدير",
        "translator": "مترجم"
      },
      "statuses": {
        "pending": "قيد الانتظار",
        "accepted": "مقبول",
        "declined": "مرفوض"
      }
    },
    "errors": {
      "role": "يجب اختيار دور",
      "domains": "يجب اختيار موقع واحد على الأقل من المواقع للدور الذي تم تحديده",
      "languages": "يجب اختيار لغة واحدة على الأقل من اللغات للمواقع التي تم تحديدها"
    },
    "inviteSent": "تم إرسال الدعوة بنجاح"
  },
  "pagination": {
    "showing": "عرض {{limit}} من {{total}} نتيجة",
    "showing_only_count": "عرض {{limit}} نتيجة"
  },
  "payments_method": {
    "header": "طرق الدفع",
    "table": {
      "title": "قائمة طرق الدفع",
      "description": "طرق الدفع المرفقة بحسابك",
      "default": "افتراضي",
      "action_edit_remove": "تعديل أو إزالة",
      "action_remove": "إزالة",
      "action_default": "تعيين كافتراضي",
      "action_fallback": "تعيين كاحتياطي",
      "expires": "تنتهي في",
      "add_new_card": "إضافة طريقة دفع",
      "action_fallback_remove": "إزالة من الاحتياطي",
      "fallback": "الاحتياطي",
      "action_edit": "تعديل",
      "action_delete": "حذف",
      "action_default_remove": "إزالة كافتراضي",
      "domain_count@@one": "يستخدمها {{count}} نطاقات",
      "domain_count@@other": "يستخدم بواسطة {{count}} نطاقًا"
    },
    "paypal_bind": {
      "button": "ربط حساب PayPal",
      "button_load": "جاري الربط...",
      "disconnected": "غير متصل",
      "success": "تم ربط حساب PayPal الآن، سيتم خصم 5 دولارات من فاتورتك التالية!",
      "success_no_promo": "تم ربط حساب PayPal الآن",
      "error": "حدث خطأ",
      "success_header": "نجاح"
    },
    "card_add": {
      "header": "إضافة بطاقة جديدة",
      "success": "تم ربط بطاقة جديدة بـ Linguise!",
      "terms": "من خلال تزويدنا بمعلومات بطاقتك، تسمح لـ Linguise بخصم بطاقتك للمدفوعات المستقبلية وفقًا لشروط الخدمة الخاصة بنا."
    },
    "card_detail": {
      "header": "معلومات البطاقة",
      "delete": {
        "error": "لا يمكنك حذف طريقة الدفع لأنها تحتوي على اشتراكات نشطة!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "الاشتراكات على طريقة الدفع هذه",
        "header_domain": "النطاق",
        "header_plan": "الخطة",
        "header_status": "الحالة",
        "header_actions": "الإجراءات",
        "cancelling": "يتم الإلغاء في: {{0}}",
        "next_payment": "الدفع التالي في: {{0}}",
        "action_renew": "التجديد",
        "no_subs_header": "لا توجد اشتراكات لعرضها",
        "no_subs_desc": "بمجرد إنشاء اشتراك لهذه البطاقة، ستُعرض جميع المعلومات هنا",
        "action_manage": "إدارة"
      },
      "status": {
        "active": "نشط",
        "canceled": "مُلغى",
        "incomplete": "غير مدفوع",
        "incomplete_expired": "غير مدفوع (منتهي)",
        "missing": "خطأ",
        "past_due": "متأخر",
        "trialing": "تجريبي",
        "unpaid": "غير مدفوع"
      }
    },
    "delete_confirm_body": "هل أنت متأكد من رغبتك في حذف طريقة الدفع؟ لا يمكن التراجع عن هذا الإجراء!",
    "delete_confirm_header": "حذف طريقة الدفع؟",
    "card_edit": {
      "header": "تعديل البطاقة",
      "billing_header": "معلومات الفواتير",
      "address_error": "العنوان مطلوب!",
      "card_number": "رقم البطاقة",
      "card_expiry": "تاريخ الانتهاء",
      "expiry_error_month": "تم توفير شهر غير صالح",
      "expiry_error_year": "تم توفير سنة غير صالحة",
      "expiry_error_expired": "سنة انتهاء صفحتك مضت.",
      "card_header": "معلومات البطاقة",
      "expiry_error_empty": "هذا الحقل مطلوب!"
    }
  },
  "plans": {
    "per": "لكل",
    "wordsTranslated": "كلمة مترجمة",
    "current": "الحالي",
    "archived": "مؤرشف",
    "day": "يوم",
    "week": "أسبوع",
    "month": "شهر",
    "year": "سنة",
    "activate": "تفعيل",
    "cancel": "إلغاء",
    "change": "تغيير",
    "upgrade": "ترقية",
    "downgrade": "تخفيض",
    "resume": "استئناف",
    "notEnoughWords": "عدد الكلمات غير كاف",
    "yearIntervalOnly": "لا يمكن الترحيل من الخطة السنوية",
    "subsCanceled": "هناك إلغاء اشتراك آخر قيد التنفيذ",
    "wordsUnlimited": "كلمات غير محدودة",
    "tabs": {
      "day": "أسعار يومية",
      "week": "أسعار أسبوعية",
      "month": "أسعار شهرية",
      "year": "أسعار سنوية",
      "sub_texts": {
        "day": "سعر ثابت واحد، كل يوم",
        "week": "سعر ثابت واحد، كل أسبوع",
        "month": "سعر ثابت واحد، كل شهر",
        "year": "شهر مجاني، فاتورة واحدة سنويًا"
      }
    },
    "details": {
      "new_languages": "أضف لغات جديدة في أي وقت",
      "one_month_trial": "تجربة مجانية لمدة شهر لكل موقع ويب جديد",
      "multi_content_indexed": "فهرسة 100% من المحتوى متعدد اللغات",
      "translate_new_content": "ترجمة المحتوى الجديد فورًا",
      "free_installation": "التثبيت والإعداد مجانًا",
      "compared_monthly_plan": "شهر مجاني مقارنة بالخطط الشهرية",
      "risk_free_recurring": "فشل متكرر في الدفع بدون مخاطر",
      "unlimited_languages": "لغات ومعاينات صفحات غير محدودة",
      "high_server_resources": "موارد خادم عالية",
      "billed": {
        "day": "تُحاسب يوميًا",
        "week": "تُحاسب أسبوعيًا",
        "month": "تُحاسب شهريًا",
        "year": "تُحاسب سنويًا"
      },
      "request_max_size": "{{0}} الحد الأقصى لحجم الطلب"
    },
    "frequent_question": {
      "title": "الأسئلة المتكررة",
      "questions": {
        "trial": {
          "question": "هل يمكنني استخدام التجربة على نطاق موقع ويب جديد؟",
          "answer": "نعم، نوفر تجربة مجانية لمدة 30 يومًا لكل نطاق موقع ويب جديد تضيفه إلى حسابك؛ بهذا يمكنك اختبار خدمة الترجمة بالكامل على موقعك الجديد."
        },
        "seo": {
          "question": "كم تستغرق وقتًا لتحسين محركات البحث الخاصة بي؟",
          "answer": "يستغرق المحتوى، وخصوصًا المحتوى متعدد اللغات، وقته ليتم فهرسته بالكامل وتصنيفه بشكل جيد. حسب حركة المرور وحجم موقعك، تكون المدة بين 3 و6 أسابيع."
        },
        "quota": {
          "question": "هل تُحسب الترجمات البشرية ضمن الحصة؟",
          "answer": "لا، الحد لعدد الكلمات يُطبق فقط على الترجمات الآلية. يمكن للمترجم تعديل الترجمات الآلية يدويًا دون حدود."
        }
      }
    },
    "best_offer": "أفضل عرض",
    "period": {
      "days@@one": "يوم",
      "days@@other": "{{count}} أيام",
      "hours@@one": "ساعة",
      "hours@@other": "{{count}} ساعات",
      "minutes@@one": "دقيقة",
      "minutes@@other": "{{count}} دقائق",
      "seconds@@one": "ثانية",
      "seconds@@other": "{{count}} ثوان"
    },
    "words": {
      "billion": "{{value}} مليار",
      "million": "{{value}} مليون",
      "thousand": "{{value}} ألف"
    },
    "throttling_info": "{{words}} كلمة لكل {{period}}"
  },
  "profile": {
    "welcome": "مرحبًا!",
    "account": "حسابي",
    "subscriptions": "الاشتراكات",
    "logout": "تسجيل الخروج"
  },
  "register": {
    "errors": {
      "password": "الحد الأدنى 8 أحرف، أي حرف"
    }
  },
  "route": {
    "dashboard": "لوحة التحكم",
    "rules": "القواعد",
    "translations": "الترجمات",
    "search_translations": "استعلامات البحث",
    "urls_translations": "ترجمات العناوين",
    "links": "الروابط الخارجية والوسائط",
    "online_editor": "المحرر المباشر",
    "settings": "الإعدادات",
    "domain": {
      "finish": "الإعدادات",
      "preconfig": "الإعدادات"
    },
    "home": "الرئيسية",
    "domain_list": "قائمة النطاقات",
    "members": "الأعضاء",
    "invoices": "الفواتير",
    "billing": "تفاصيل الدفع",
    "language_display": "عرض أعلام اللغة",
    "payment_methods": "طرق الدفع",
    "ai_translation": "ترجمة الذكاء الاصطناعي",
    "ai_translation_settings": "الإعدادات",
    "ai_translation_pricing": "الأسعار"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "نص لتجاهله",
        "add": "إضافة جديد",
        "title": "نص لتجاهله",
        "description": "أضف نصًا واحدًا أو أكثر لتجاهله",
        "ignore_case": "تجاهل حالة الأحرف"
      },
      "html_content": {
        "title": "تطبيق على محتوى HTML",
        "description": "طبّق القاعدة على كامل المحتوى أو باختيار منتقي CSS محدد",
        "all_page": "كل الصفحة",
        "css_selector": "منتقي CSS",
        "label": "منتقي CSS",
        "placeholder": "منتقى للتطبيق عليه",
        "add": "إضافة جديد"
      },
      "apply_to_urls": {
        "title": "التطبيق على عناوين URL",
        "description": "حدد عناوين URL المحددة التي تريد تطبيق القاعدة عليها",
        "all_urls": "جميع عناوين URL",
        "selected_urls": "عناوين URL محددة",
        "label": "عنوان URL للتطبيق عليه",
        "placeholder": "عنوان URL للتطبيق عليه",
        "original_url": "عناوين URL الأصلية",
        "translated_url": "عنوان URL المترجم",
        "wildcard": "حرف بدل",
        "regex": "تعبير عادي",
        "add": "إضافة جديد",
        "expression": "نوع التعبير"
      },
      "apply_urls": {
        "title_exclude": "استبعاد في عناوين URL",
        "title_replace": "الاستبدال في عناوين URL",
        "title_description": "قم أيضًا بتطبيق هذه القاعدة على ترجمة عناوين URL"
      },
      "apply_languages": {
        "title": "التطبيق على اللغات",
        "description": "حدد لغة معينة تريد تطبيق القاعدة عليها",
        "all_languages": "جميع اللغات",
        "selected_languages": "لغات محددة",
        "placeholder": "تحديد اللغات...",
        "feedback": "يجب عليك اختيار لغة"
      },
      "name": {
        "title": "العنوان",
        "description": "امنح قاعدتك عنوانًا لراحتك",
        "placeholder": "اسم القاعدة"
      },
      "type": {
        "title": "النوع",
        "description": "اختر نوع القاعدة التي تريد إضافتها",
        "text_ignore": "تجاهل النص",
        "text_replace": "استبدال النص",
        "content_exclusion": "استبعاد المحتوى",
        "url_exclusion": "الاستبعاد حسب عنوان URL",
        "ignore_inline": "تجاهل المضمون المضمن",
        "full_description": {
          "text_ignore": "أضف قواعد لتجنب ترجمة بعض النصوص. يمكن أن يكون اسم منتجك أو اسم علامتك التجارية أو عناصر فنية أخرى لا ترغب في ترجمتها.",
          "text_replace": "يتيح لك استبدال النص استبدال بعض النصوص بالترجمة التي تريدها، وقد يكون ذلك ضروريًا عندما تتجاهل الترجمة السياق.",
          "content_exclusion": "يساعدك استبعاد المحتوى على تجنب ترجمة بعض المحتوى في الصفحة.\n إذا كنت ترغب في استبعاد صفحة بالكامل من الترجمة (بدون عنوان URL متعدد اللغات على الإطلاق لهذه الصفحة وبدون محتوى مترجم)، فيُرجى استخدام نوع \"الاستبعاد حسب عنوان URL\"",
          "url_exclusion": "سيساعدك استبعاد ترجمة الصفحة على تحديد الصفحات التي لا ترغب في ترجمتها.",
          "ignore_inline": "تجنب ترجمة بعض المحتوى كمحتوى مضمن، وبدلاً من ذلك ترجمة كل علامة على حدة."
        }
      },
      "text_replace": {
        "title": "النص المراد استبداله",
        "description": "استبدل بعض النصوص بترجمتك المحددة. استبدل أي نص في جميع صفحاتك، حسب اللغة...",
        "text_to_replace": "النص المراد استبداله",
        "ignore_case": "تجاهل حالة الأحرف",
        "text_type": "الاستبدال في الترجمة",
        "text_type_original": "الأصل",
        "text_type_translation": "الترجمة",
        "keep_case": "حاول الاحتفاظ بالحالة",
        "add": "إضافة جديد"
      },
      "content_exclusion": {
        "title": "استبعاد المحتوى",
        "description": "حدد محدِّدًا أو أكثر من محدِّدات CSS لن يتم ترجمته",
        "label": "محدِّد CSS",
        "placeholder": "المحدِّد للتطبيق عليه",
        "add": "إضافة جديد"
      },
      "multilingual_url": {
        "title": "استخدام عنوان URL متعدد اللغات",
        "description": "إذا تم تعيينه على نعم، فلن يتم ترجمة عنوان URL ولكن ستظل الصفحة متعددة اللغات مع محتوى مترجم",
        "live_example_title": "مثال مباشر",
        "live_example_description": "عنوان URL المصدر: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "عنوان URL الذي تم إنشاؤه: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "عنوان URL الذي تم إنشاؤه: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "قم بتطبيق القاعدة على المحتوى الثابت أو المحتوى الديناميكي أو كليهما",
        "title": "التطبيق على المحتوى",
        "all": "كل المحتوى",
        "static": "المحتوى الثابت",
        "dynamic": "المحتوى الديناميكي"
      },
      "force_apply_urls": {
        "title_description": "فرّق تطبيق هذه القاعدة على جميع ترجمات عناوين URL، بما في ذلك الترجمات الموجودة!",
        "title_replace": "الاستبدال الإجباري في عناوين URL",
        "title_exclude": "الاستبعاد الإجباري في عناوين URL",
        "warning": "تحذير",
        "warning_part1": "قد يؤدي تعيين هذا على \"نعم\" إلى كسر ترجمات عناوين URL الخاصة بموقعك.",
        "warning_part2": "قد يؤدي ذلك إلى إنشاء صفحة خطأ 404 مؤقتة أو دائمة، يُرجى المتابعة فقط إذا كنت تفهم العواقب.",
        "warning_replacement_original": "تحذير إضافي: أنت تحاول استبدال محتوى أصلي قد يؤثر على عنوان URL، وقد تفشل الترجمة لأن Linguise غير قادر على العثور على عناوين URL الأصلية بشكل صحيح"
      }
    },
    "main": {
      "parent": "القواعد",
      "edit": "تعديل القاعدة",
      "add": "قاعدة جديدة"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "سيتم تجاهل \"{{text_ignore}}\" في المحتوى وفي عنوان URL",
      "preview_single": "سيتم تجاهل \"{{text_ignore}}\" في المحتوى",
      "preview_more_with_url": "سيتم تجاهل \"{{text_ignore}}\" و{{count}} المزيد في المحتوى وفي عنوان URL",
      "preview_more": "سيتم تجاهل \"{{text_ignore}}\" و{{count}} المزيد في المحتوى",
      "other_parameters": "تم تعيين معلمات أخرى لهذه القاعدة، انقر فوق زر التعديل للحصول على مزيد من المعلومات"
    },
    "text_replace": {
      "preview_single_with_url": "يتم استبدال \"{{original}}\" بـ \"{{replacement}}\" في المحتوى وعناوين URL",
      "preview_single": "يتم استبدال \"{{original}}\" بـ \"{{replacement}}\" في المحتوى",
      "preview_more_with_url": "يتم استبدال \"{{original}}\" بـ \"{{replacement}}\" في المحتوى وعناوين URL، و{{nb}} إضافي",
      "preview_more": "يتم استبدال \"{{original}}\" بـ \"{{replacement}}\" في المحتوى، و{{nb}} إضافي",
      "other_parameters": "تم تعيين معلمات أخرى لهذه القاعدة، انقر فوق زر التعديل للحصول على مزيد من المعلومات"
    },
    "content_exclusion": {
      "selectors": "{{nb}} محدِّد CSS مستبعد من الترجمة",
      "other_parameters": "تم تعيين معلمات أخرى لهذه القاعدة، انقر فوق زر التعديل للحصول على مزيد من المعلومات"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} من عناوين URL مستبعدة من الترجمة، لكنها تحتفظ بالبادئة متعددة اللغات",
      "some": "{{nb}} من عناوين URL مستبعدة بالكامل من الترجمة",
      "all_multilingual": "جميع عناوين URL مستبعدة من الترجمة، لكنها تحتفظ بالبادئة متعددة اللغات",
      "all": "جميع عناوين URL مستبعدة بالكامل من الترجمة",
      "other_parameters": "تم تعيين معلمات أخرى لهذه القاعدة، انقر فوق زر التعديل للحصول على مزيد من المعلومات"
    },
    "ignore_inline": {
      "elements": "سيتم ترجمة كل المحتوى المضمن كمحتوى كتلة في الصفحة",
      "all_elements": "سيتم ترجمة بعض المحتوى المضمن كمحتوى كتلة في الصفحة",
      "other_parameters": "تم ضبط معايير أخرى لهذه القاعدة، انقر فوق زر التحرير للحصول على مزيد من المعلومات"
    },
    "title": "إدارة القواعد",
    "description": "أدِر استثناءات واستبدالات محتوى الترجمة في جميع أنحاء موقعك",
    "add": "إضافة قاعدة جديدة",
    "table": {
      "title": "العنوان",
      "no_data": "لا توجد قواعد هنا حتى الآن",
      "type": "النوع",
      "preview": "معاينة القاعدة",
      "action": "الإجراء",
      "delete_confirm": "يُرجى تأكيد حذف القاعدة",
      "types": {
        "text_ignore": "تجاهل النص",
        "text_replace": "استبدال النص",
        "content_exclusion": "استبعاد المحتوى",
        "url_exclusion": "استبعاد الرابط",
        "ignore_inline": "تجاهل المضمّن",
        "unknown": "قاعدة غير معروفة"
      }
    },
    "apply_on_content": {
      "static": "سيتم تطبيق هذه القاعدة فقط على المحتوى الثابت",
      "dynamic": "سيتم تطبيق هذه القاعدة فقط على المحتوى الديناميكي"
    }
  },
  "search_translations": {
    "title": "إدارة استعلامات البحث",
    "description": "سرد كل ترجمات موقعك المستخدمة عبر نماذج البحث (من اللغة المترجمة إلى لغة نطاقك الأساسية)",
    "filter_languages": "تصفية حسب اللغات...",
    "filter_original": "تصفية النص باللغة الأصلية",
    "filter_translation": "تصفية حسب النص المترجم",
    "table": {
      "original": "الأصلي",
      "language": "اللغة",
      "translation": "الترجمة"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "فشل الاشتراك!",
      "title": "فشل الاشتراك!",
      "subtitle": "حدث خطأ أثناء محاولة معالجة اشتراكك.",
      "home": "العودة إلى الرئيسية",
      "generic": "حدث خطأ غير معروف من جانب Linguise، يرجى التواصل مع المسؤول!"
    },
    "success": {
      "home": "إدارة ترجمات النطاق",
      "message": "نحن ملتزمون بتوفير أفضل تجربة ترجمة ممكنة. فريق الخبراء لدينا متاح لمساعدتك في أي أسئلة أو دعم تحتاجه. للبدء، ما عليك سوى النقر على الزر أدناه.",
      "subtitle": "شكراً لاختيارك خدمة ترجمة Linguise",
      "title": "تم تفعيل الاشتراك!",
      "tab_title": "شكراً للاشتراك!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "تم تفعيل الاشتراك!",
      "title": "تم تفعيل الاشتراك!",
      "subtitle": "شكراً لاختيارك خدمة ترجمة Linguise",
      "message": "نحن ملتزمون بتوفير أفضل تجربة ترجمة ممكنة. فريق الخبراء لدينا متاح لمساعدتك في أي أسئلة أو دعم تحتاجه. للبدء، ما عليك سوى النقر على الزر أدناه.",
      "home": "إدارة ترجمات النطاق"
    },
    "edit": {
      "title": "إدارة الاشتراك"
    },
    "list": {
      "title": "قائمة الاشتراكات",
      "description": "قائمة اشتراكات نطاقك"
    },
    "table": {
      "domain": "النطاق",
      "plan": "الخطة",
      "status": "الحالة",
      "card": "البطاقة",
      "usage": "الاستخدام",
      "actions": "الإجراءات",
      "payment_method": "طريقة الدفع"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} كلمة",
      "paidOffered": "{{words_used}} / {{words_allowed}} كلمة\n(تتضمن {{free_words}} كلمات مجانية)"
    },
    "popup": {
      "dueToday": "إجمالي المستحق اليوم",
      "nextPeriod": "ابتداء من {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "اختر حساباً"
    }
  },
  "translation": {
    "main": {
      "parent": "الترجمات",
      "edit": "تعديل الترجمة"
    },
    "form": {
      "original": {
        "title": "النص الأصلي بلغة {{language}}"
      },
      "is_inline": "هذه الترجمة مأخوذة من محتوى مضمّن.",
      "inline_editor": {
        "count_warning": "عدد المناطق المضمنة لا يطابق الأصل ({{current}} من {{expected}}).",
        "restore_original": "استعادة النص الأصلي",
        "insert_placeholder": "إدراج عنصر نائب",
        "drag": "اسحب لإعادة ترتيب المنطقة المضمنة",
        "area": "منطقة مضمّنة {{index}}",
        "restore": "استعادة المناطق المضمنة المفقودة"
      },
      "translation": {
        "title": "الترجمة بلغة {{language}}",
        "description": "الترجمة التي ترغب في تجاوزها"
      }
    },
    "copy": {
      "title": "نسخ إلى الترجمة اليدوية",
      "label": "نسخ إلى اليدوية"
    },
    "level": {
      "base": {
        "title": "الترجمة الأساسية",
        "subtitle": "تلقائية · ترجمة Linguise Cloud",
        "empty": "لا توجد ترجمة أساسية لهذا النص.",
        "overridden": "اختيارك محفوظ، لكن أحدث ترجمة محسّنة بالذكاء الاصطناعي تُعرض بدلاً منه لأن خيار «تجاوز الترجمات اليدوية والمحددة» مضبوط على «نعم» في إعدادات ترجمة AI. أوقف هذا الخيار لاستخدام اختيارك."
      },
      "not_generated": "لم يتم إنشاؤها",
      "none": "لا شيء بعد",
      "ai": {
        "title": "الترجمة المحسّنة بالذكاء الاصطناعي",
        "subtitle": "تلقائية · Linguise AI",
        "empty_title": "لم يتم إنشاؤها لهذا النص بعد",
        "empty_description": "يقدّم Linguise AI ترجمات أكثر طبيعية باستخدام سياق صفحتك وموقعك. للحصول على واحدة هنا:",
        "empty_step_1": "انتقل إلى ترجمة AI › الإعدادات واضبط «تفعيل ترجمة AI» على «قواعد فقط» أو «المحرر المباشر فقط» أو «القواعد والمحرر المباشر».",
        "empty_step_2": "طبّقها بقاعدة تطابق هذه الصفحة، أو فعّلها صفحة بصفحة من المحرر المباشر.",
        "empty_step_3": "ستظهر الترجمة المحسّنة بالذكاء الاصطناعي هنا بمجرد إنشائها. وتستهلك رصيد AI الخاص بك.",
        "open_settings": "فتح إعدادات ترجمة AI",
        "open_editor": "فتح المحرر المباشر",
        "overrides_selection": "اختيارك محفوظ، لكن هذه الترجمة المحسّنة بالذكاء الاصطناعي تُعرض بدلاً منه لأن خيار «تجاوز الترجمات اليدوية والمحددة» مضبوط على «نعم» في إعدادات ترجمة AI. أوقف هذا الخيار لاستخدام اختيارك.",
        "overrides_version": "النسخة التي اخترتها محفوظة، لكن أحدث نسخة محسّنة بالذكاء الاصطناعي تُعرض بدلاً منها لأن خيار «تجاوز الترجمات اليدوية والمحددة» مضبوط على «نعم» في إعدادات ترجمة AI. أوقف هذا الخيار لاستخدام النسخة المحددة."
      },
      "manual": {
        "title": "الترجمة اليدوية",
        "subtitle": "من كتابتك · لها الأولوية على الترجمات التلقائية",
        "empty": "فارغة",
        "saved_but_overridden": "تم حفظها كاختيارك، لكنها لا تُعرض تلقائيًا لأن خيار «تجاوز الترجمات اليدوية» مضبوط على «نعم» في إعدادات ترجمة AI: تكون الغلبة للترجمة المحسّنة بالذكاء الاصطناعي إلى أن يتم إيقاف هذا الخيار.",
        "ignored": "لا تُعرض تلقائيًا لأن خيار «تجاوز الترجمات اليدوية» مضبوط على «نعم» في إعدادات ترجمة AI. اخترها لاستخدامها لهذا النص.",
        "label": "ترجمتك",
        "placeholder": "اكتب ترجمتك الخاصة...",
        "last_updated": "آخر تعديل {{date}}",
        "save_hint": "حفظ الترجمة اليدوية يجعلها فعّالة.",
        "delete": "حذف الترجمة اليدوية",
        "delete_confirm": "يرجى تأكيد حذف الترجمة اليدوية"
      }
    },
    "history": {
      "title": "إصدارات محسّنة بالذكاء الاصطناعي",
      "subtitle": "يتم الاحتفاظ بكل إعادة إنشاء من المحرر المباشر",
      "unknown_model": "نموذج غير معروف",
      "current": "الحالي",
      "restore": "استعادة هذا الإصدار",
      "restore_note": "تؤدي الاستعادة إلى جعل ذلك الإصدار هو الترجمة الحالية المحسّنة بالذكاء الاصطناعي. لا يتم حذف أي شيء.",
      "version_of": "الإصدار {{current}} من {{total}}",
      "hide": "إخفاء السجل ({{total}})",
      "show": "عرض السجل ({{total}})"
    },
    "choose": {
      "title": "الترجمات إلى {{language}} · اختر ما يراه الزوار",
      "current": "المعروضة حاليًا على موقعك:",
      "priority": "الأولوية الافتراضية: يدوية › محسّنة بالذكاء الاصطناعي › أساسية. يُحفظ اختيارك لهذه الترجمة فقط.",
      "reset": "إعادة التعيين إلى الأولوية الافتراضية",
      "reset_title": "تجاهل اختيارك لهذا النص واستخدام الأولوية الافتراضية مجددًا",
      "resetting": "جارٍ إعادة التعيين..."
    }
  },
  "translations": {
    "title": "إدارة الترجمات",
    "description": "سرد وتعديل كل ترجمات موقعك، للترجمة المرئية استخدم المحرر المباشر",
    "filter_languages": "تصفية حسب اللغات...",
    "filter_original": "تصفية النص باللغة الأصلية",
    "filter_translation": "تصفية حسب النص المترجم",
    "table": {
      "original": "الأصلي",
      "language": "اللغة",
      "action": "الإجراء",
      "base": "الأساسية",
      "ai": "محسّنة بالذكاء الاصطناعي",
      "manual": "اليدوية"
    },
    "filter_exact": "تطابق تام",
    "badge": {
      "active": "فعّالة",
      "overrides_manual": "تتجاوز اليدوية"
    },
    "cell": {
      "none": "لا شيء",
      "not_generated": "لم يتم إنشاؤها",
      "ignored": "متجاهَلة – قاعدة AI هي الأقوى"
    },
    "tabs": {
      "all": "الكل",
      "manual": "فيها يدوية",
      "ai": "فيها محسّنة بالذكاء الاصطناعي",
      "base": "أساسية فقط"
    },
    "levels_hint": "لكل نص حتى 3 مستويات — المستوى المعلَّم بـ«فعّالة» هو ما يراه الزوار."
  },
  "url": {
    "main": {
      "parent": "الروابط",
      "edit": "تعديل ترجمة الرابط"
    },
    "form": {
      "original": {
        "title": "النص الأصلي بلغة {{language}}"
      },
      "translation": {
        "title": "ترجمة الرابط بلغة {{language}}",
        "description": "الرابط الذي ترغب في تجاوزه",
        "placeholder": "تجاوز ترجمة الرابط",
        "invalid_full": "أنت تحاول التغيير بتنسيق غير صحيح، يجب أن تغيّر فقط الأجزاء المختصرة/مسار الصفحة من ترجمة الرابط",
        "invalid": "تم تقديم رابط/مسار غير صالح"
      }
    }
  },
  "urls": {
    "title": "إدارة الروابط",
    "description": "سرد وتعديل كل محتوى روابط موقعك المترجم (متقدم، احذر أخطاء 404)",
    "filter_languages": "تصفية حسب اللغات...",
    "filter_original": "تصفية النص باللغة الأصلية",
    "filter_translation": "تصفية حسب النص المترجم",
    "table": {
      "original": "الأصلي",
      "language": "اللغة",
      "url": "الرابط المترجم",
      "action": "الإجراء",
      "edited": "تم تعديل النص الأصلي للرابط"
    }
  }
}
